<template>
  <div>
    <div>
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="card-title">{{$t('Contracts')}}</h4>
          <span class="badge badge-success" style="float: right"
            >Total: {{ contracts.total }}</span
          >
        </div>
        <div class="card-content">
          <div class="card-body pb-1">
            <div class="row align-items-center justify-content-center mt-2">
              <div class="col-12">
                <div
                  id="contract-payments-chart"
                  class="d-flex justify-content-center"
                ></div>
              </div>
              <!-- <div class="col">
                <ul class="list-group list-group-flush">
                  <li
                    class="list-group-item border-0 d-flex align-items-center justify-content-between px-0"
                  >
                    <strong>Average Contract Duration: </strong>
                    <span v-if="contracts.averageContractDuration">
                      {{ contracts.averageContractDuration.toFixed(2) }} months
                    </span>
                  </li>
                </ul>
              </div> -->
            </div>

            <div class="row mt-2 mb-1">
              <div class="col-md-6 col-sm-12">
                <strong>{{$t('Contract Duration')}}: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="contracts.averageContractDuration"
                >
                  {{ contracts.averageContractDuration.toFixed(2) }} {{$t('months')}}
                  {{$t('(Average)')}}
                </span>
              </div>
            </div>

            <div class="row justify-content-between mb-2">
              <div class="col-md-6 col-sm-12">
                <strong>{{$t('Payment Recurrence')}}: </strong>
              </div>
              <div class="col-md-6 col-sm-12 justify-content-end d-flex">
                <span
                  class="badge badge-primary"
                  v-if="contracts.averagePaymentRecurrence"
                >
                  {{ contracts.averagePaymentRecurrence.toFixed(2) }} {{$t('months')}}
                  {{$t('(Average)')}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
  props: ["contracts"],
  methods: {
    initPaymentsChart() {
      const donutChartOption = {
        chart: {
          width: 200,
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        series: [],
        labels: [],
        stroke: {
          width: 0,
          lineCap: "round",
        },
        colors: ["#00CFDD", "#FDAC41", "#5A8DEE", "#39DA8A"],
        plotOptions: {
          pie: {
            donut: {
              size: "90%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "15px",
                  colors: "#596778",
                  offsetY: 20,
                  fontFamily: "IBM Plex Sans",
                },
                value: {
                  show: true,
                  fontSize: "26px",
                  fontFamily: "Rubik",
                  color: "#475f7b",
                  offsetY: -20,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#828D99",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce(function (a, b) {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        legend: {
          show: false,
        },
      };

      const donutChart = new ApexCharts(
        document.querySelector("#contract-payments-chart"),
        donutChartOption
      );

      this.contracts.paymentTypes.counts.forEach((type) => {
        for (const [key, value] of Object.entries(type)) {
          donutChartOption.labels.push(key.replaceAll("_", " "));
          donutChartOption.series.push(value);
        }
      });

      donutChart.render();
    },
  },

  mounted() {
    this.initPaymentsChart();
  },
};
</script>